import { useAuth } from "@/hooks/use-auth";

export type AccessReason =
  | { type: "loading" }
  | { type: "unauthenticated" }
  | { type: "rate-limited"; retryAfter?: number }
  | null;

export function useAccessGuard(): { isAllowed: boolean; reason: AccessReason } {
  // Signing in with an emailed code verifies the address, so there's no "unverified" state.
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return { isAllowed: false, reason: { type: "loading" } };
  if (!isAuthenticated) return { isAllowed: false, reason: { type: "unauthenticated" } };

  return { isAllowed: true, reason: null };
}
